import React from "react";
import { useDelete } from "../../../../api/useCall";
import t from "../../../../i18n";
import { useNavigate } from "react-router";
import ModalForm from "@ui/Modal/Form";
import { useMutateBody } from "../../../../api/useQuery";
import Text from "@ui/Text";
import AdditionnalMessage from "@ui/AdditionnalMessage";
import { toPath } from "../../../../router/helpers/path";

interface P {
  closeDeleteFiltersModal: () => void;
  projectId: string;
}

const DeleteFiltersModalForm = ({ closeDeleteFiltersModal, projectId }: P) => {
  const deleteFilters = useDelete("/projects/:projectId(uuid)/activationFilters");
  const navigate = useNavigate();
  const mutateQuantities = useMutateBody("/projects/:projectId(uuid)/quantities", {
    routeParams: { projectId },
  });

  const handleSubmit = React.useCallback(async () => {
    mutateQuantities(({ collection, ...rest }) => ({
      ...rest,
      collection: collection.map(q => ({
        ...q,
        maxActivation: null,
        minActivation: null,
        maxStdActivation: null,
      })),
    }));
    await deleteFilters({
      routeParams: { projectId },
    });
    void navigate(toPath("/projects/:projectId/settings", { projectId }));
    return true;
  }, [deleteFilters, projectId, navigate, mutateQuantities]);

  return (
    <ModalForm
      onRequestClose={closeDeleteFiltersModal}
      onSubmit={handleSubmit}
      okButtonName={t("project.settings.analyses.delete_filters.modal.submit_button.label")}
      okButtonVariant="destructive"
    >
      <>
        <Text>{t("project.settings.analyses.delete_filters.modal.description")}</Text>
        <AdditionnalMessage
          status="INFO"
          text={t("project.setting.filter.modal.delete.additionnal_message.info")}
        />
      </>
    </ModalForm>
  );
};

export default React.memo(DeleteFiltersModalForm);
